<script>
import u from '@/utils'

export default {
  name: 'CredentialDetail',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    updatable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: this.optionsFromValue()
    }
  },

  methods: {
    update(field, index, property, value) {
      field[property] = value
      this.$set(this.options, index, field)
      if (property === 'value') {
        this.$emit(
          'input',
          this.options.map(option => {
            delete option.secureVisible
            return option
          })
        )
      }
    },

    optionsFromValue() {
      return u.clone(this.value).map(option => {
        if (!option.value) {
          option.value = ''
        }
        if (option.secure) {
          option.secureVisible = false
        }
        if (this.updatable) {
          option.readonly = true
        }
        return option
      })
    },

    resetField(field) {
      this.editField(field, false)
      this.options.forEach(option => {
        if (option.key === field.key) {
          this.value.forEach(valueOption => {
            if (valueOption.key === field.key) {
              if (valueOption.value) {
                option.value = valueOption.value
              } else {
                option.value = ''
              }
            }
          })
        }
      })
    },

    setField(field, value) {
      this.editField(field, false)
      let saveBody = {}
      saveBody[field.key] = value
      this.$emit('save', saveBody)
    },

    editField(field, flag) {
      this.options.forEach(option => {
        if (option.key === field.key) {
          option.readonly = !flag
        }
      })
    }
  },

  watch: {
    value() {
      this.options = this.optionsFromValue()
    }
  }
}
</script>
<template>
  <div>
    <div v-for="(field, i) in options" :key="i">
      <v-select
        :outline="$vuetify.dark"
        color="secondary"
        v-if="field.options"
        item-text="friendlyName"
        item-value="key"
        :items="field.options"
        :value="field.value"
        @input="update(field, i, 'value', $event)"
        :label="field.friendlyName"
        :key="field.key"
        return-object
        :readonly="readonly || field.readonly"
      >
        <template slot="append-outer" v-if="!readonly && updatable">
          <template v-if="!field.readonly">
            <v-icon @click="resetField(field)">clear</v-icon>
            <v-icon @click="setField(field, field.value.key)">save</v-icon>
          </template>
          <v-icon v-else @click="editField(field, true)">edit</v-icon>
        </template>
      </v-select>
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        v-else-if="field.secure"
        :value="field.value"
        @input="update(field, i, 'value', $event)"
        :type="field.secureVisible ? 'text' : 'password'"
        :key="field.key"
        :label="field.friendlyName"
        @click:append="update(field, i, 'secureVisible', !field.secureVisible)"
        :readonly="readonly || field.readonly"
      >
        <template slot="append-outer" v-if="!readonly && updatable">
          <template v-if="!field.readonly">
            <v-icon @click="resetField(field)">clear</v-icon>
            <v-icon @click="setField(field, field.value)">save</v-icon>
          </template>
          <v-icon v-else @click="editField(field, true)">edit</v-icon>
        </template>
      </v-text-field>
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        v-else
        :value="field.value"
        @input="update(field, i, 'value', $event)"
        :key="field.key"
        :label="field.friendlyName"
        :readonly="readonly || field.readonly"
      >
        <template slot="append-outer" v-if="!readonly && updatable">
          <template v-if="!field.readonly">
            <v-icon @click="resetField(field)">clear</v-icon>
            <v-icon @click="setField(field, field.value)">save</v-icon>
          </template>
          <v-icon v-else @click="editField(field, true)">edit</v-icon>
        </template>
      </v-text-field>
    </div>
  </div>
</template>
